import type { EventableType, EventApprovalStatus } from "@/api/events/types";
import type { GymScheduleStatus } from "@/api/gym-schedules/types";

export const EVENTABLE_TYPE = {
  GroupSession: "groupSession",
  PersonalTrainingSession: "personalTrainingSession",
  PhysicalEvaluationSession: "physicalEvaluationSession",
  FloorDuty: "floorDuty",
  Vacancy: "vacancy",
} as const;

export const EVENTABLE_TYPES = [
  EVENTABLE_TYPE.GroupSession,
  EVENTABLE_TYPE.PersonalTrainingSession,
  EVENTABLE_TYPE.PhysicalEvaluationSession,
  EVENTABLE_TYPE.FloorDuty,
  EVENTABLE_TYPE.Vacancy,
] as const;

export const DIFFICULTY_LEVEL = {
  Beginner: "beginner",
  Intermediate: "intermediate",
  Advanced: "advanced",
} as const;

export const GYM_SCHEDULE_VIEW_TYPES = [
  EVENTABLE_TYPE.GroupSession,
  EVENTABLE_TYPE.FloorDuty,
] as const satisfies readonly EventableType[];

export type GymScheduleViewType = (typeof GYM_SCHEDULE_VIEW_TYPES)[number];

export const EVENT_APPROVAL_STATUS = {
  Pending: "pending",
  Approved: "approved",
  Rejected: "rejected",
} as const;

export const DEFAULT_EVENT_DURATION_MINUTES = 30;

export const APPROVAL_INTERACTIVE_STATUSES: GymScheduleStatus[] = [
  "pending",
  "approved",
  "published",
];

export const SCHEDULE_DETAIL_STATUSES: GymScheduleStatus[] = [
  "published",
  "completed",
];

export const APPROVAL_STATE_FILTER = {
  Approved: "approved",
  Pending: "pending",
  Rejected: "rejected",
  Conflict: "conflict",
} as const;

export type ApprovalStateFilterValue =
  | EventApprovalStatus
  | typeof APPROVAL_STATE_FILTER.Conflict;
